import Footer from "../Fotter";

const AboutUs = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <div className=" mx-auto px-4 py-6">
          <h2 className="text-5xl font-semibold text-center text-gray-800 mb-6">
            About Us
          </h2>

          <p className="text-lg text-gray-700 mb-6">
            We are Bharat’s Shopping portal based in Bharat, Delivering Products only in Bharat and this
            portal has most of the products from Bharat Manufactures.
          </p>

          <p className="text-lg text-gray-700 mb-6">
            Company :- GWSDD E-Commerce Pvt. Ltd
          </p>

          <ul className="list-inside pl-5 space-y-2 text-lg text-gray-700">
            <li>
              <strong>Registration Number:</strong> U74999MP2017PTC042932
            </li>
            <li>
              <strong>Address:</strong> Add Me Cart Office and Warehouse Location
              : THAKUR JI KI HAWELI JALPA MATA MANDIR KE PASS RAJGARH
              Rajgarh Madhya Pradesh Bharat Pin 465661
            </li>
            <li>
              <strong>Add Me Cart Server Location:</strong> Jai Stambh Chowk ,opposite Gurh Gali ,Rajgarh , Rajgarh Madhya Pradesh, Bharat ,Pin – 465661
            </li>
            <li>
              <strong>Email:</strong> info@addmecart.com  ( We try to reply every Query Within 24 working hours )
            </li>
            <li>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.addmecart.com"
                className="text-blue-500 hover:underline"
              >
                www.addmecart.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
